// src/data/fakeUsers.ts

// Types d'avatar disponibles partout sur le site
export type AvatarKind = "initial" | "boy" | "girl" | "man" | "woman";

// Profil pour un compte individuel
export type IndividualProfile = {
  id: string;
  firstName: string;
  birthYear?: number;
  avatar?: AvatarKind;
};

// Rôles possibles pour les comptes multi-profils
import type { AgeBand } from "../types/profiles";

export type FamilyProfileRole =
  | "parent"
  | "child"
  | "teacher"
  | "student"
  | "enfant"
  | "enseignant"
  | "eleve";

// Profil utilisé pour les comptes famille ET school
export type FamilyProfile = {
  id: string;
  firstName: string;
  displayName?: string;
  birthYear?: number;
  sex?: "m" | "f";
  role: FamilyProfileRole;
  avatar?: AvatarKind;
  age?: number | null;
  ageBand?: AgeBand;
};

export type AccountType = "individual" | "family" | "school";

export type BaseAccount = {
  id: string;
  email: string;
  password: string;
  type: AccountType;
  premium: boolean; // false = version gratuite (vitrine), true = plan Premium
};

export type IndividualAccount = BaseAccount & {
  type: "individual";
  profile: IndividualProfile;
};

export type FamilyAccount = BaseAccount & {
  type: "family";
  profiles: FamilyProfile[];
};

export type SchoolAccount = BaseAccount & {
  type: "school";
  profiles: FamilyProfile[]; // role = "teacher" ou "student"
};

export type Account = IndividualAccount | FamilyAccount | SchoolAccount;

// --- Comptes de démonstration (vitrine) ---

export const DEMO_ACCOUNTS: Account[] = [
  {
    id: "demo-individual",
    type: "individual",
    email: "demo@mixmind.app",
    password: "demo1234",
    premium: false,
    profile: {
      id: "demo-individual-profile",
      firstName: "Curieux",
      birthYear: 2001,
      avatar: "man",
    },
  },
  {
    id: "demo-family",
    type: "family",
    email: "family@mixmind.app",
    password: "family1234",
    premium: false,
    profiles: [
      {
        id: "emma-parent",
        firstName: "Emma",
        birthYear: 1988,
        sex: "f",
        role: "parent",
        avatar: "woman",
      },
      {
        id: "lea-child",
        firstName: "Léa",
        birthYear: 2013,
        sex: "f",
        role: "child",
        avatar: "girl",
      },
      {
        id: "tom-child",
        firstName: "Tom",
        birthYear: 2010,
        sex: "m",
        role: "child",
        avatar: "boy",
      },
    ],
  },
  {
    id: "demo-school",
    type: "school",
    email: "school@mixmind.app",
    password: "school1234",
    premium: false,
    profiles: [
      {
        id: "teacher-1",
        firstName: "Mme Durand",
        birthYear: 1985,
        sex: "f",
        role: "teacher",
        avatar: "woman",
      },
      {
        id: "student-1",
        firstName: "Noah",
        birthYear: 2011,
        sex: "m",
        role: "student",
        avatar: "boy",
      },
    ],
  },
];

// Prix fictifs pour la page Premium
export const PREMIUM_PRICING = {
  individual: {
    label: "MixMind Premium",
    pricePerMonth: "4,90 € / mois",
  },
  family: {
    label: "MixMind Family Premium",
    pricePerMonth: "7,90 € / mois",
  },
  school: {
    label: "MixMind School Premium",
    pricePerMonth: "29,00 € / mois",
  },
} as const;
